import React, { useMemo } from "react";
import PdfTable from "../../components/data/PdfTable";

const PdfBorrowerExperienceTable = ({ data, title }) => {
  const mappedRowData = [
    { timePeriod: "Last 2 years", count: data.last_two_years || 0 },
    { timePeriod: "2-4 years ago", count: data.two_to_four_years || 0 },
  ];
  const columnDefs = useMemo(
    () => [
      { headerName: "Time Period", field: "timePeriod" },
      { headerName: "Count", field: "count" },
    ],
    []
  );
  if (!data) return null;

  return (
    <PdfTable title={title} columnDefs={columnDefs} rowData={mappedRowData} />
  );
};

export default PdfBorrowerExperienceTable;
